import ConfigProvider from './ConfigProvider'
import withConfig, { IWithConfigProps as IWithConfigPropsType } from './withConfig'

export type IWithConfigProps = IWithConfigPropsType

export { ConfigProvider, withConfig }
